const formatPrice = (value: number) => {
  return `U$S ${value.toLocaleString("es")}`;
};

const formatHectares = (value: number) => {
  return `${value.toLocaleString("es")} ha.`;
};

const normalizeString = (value: string) => {
  return value.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
};

const matchSearchTerm = function <T extends Record<string, unknown>>(
  searchTerm: string,
  data: T[],
  searchModel: (item: T) => Record<string, string>
) {
  let result = [] as T[];

  if (searchTerm) {
    const searchTermRegex = new RegExp(normalizeString(searchTerm), "gim");
    result = data.filter((dataItem) => {
      const item = searchModel(dataItem);
      let itemString = "";
      for (const key in item) {
        const value = item.hasOwnProperty(key) ? item[key] : "";
        const isValidKey = value && typeof value === "string";
        if (isValidKey) {
          itemString += (value as string).toString().toLowerCase().trim() + " ";
        }
      }

      return normalizeString(itemString).match(searchTermRegex);
    });
  }

  return result;
};

export { formatPrice, formatHectares, matchSearchTerm };
